import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/pro-regular-svg-icons";

const Button = ({
  onClick = null,
  className,
  type,
  children,
  isloading = false,
}) => {
  return (
    <>
      <button
        className={className}
        type={type}
        disabled={isloading ? "disabled" : ""}
        loading={isloading.toString()}
        onClick={onClick ? onClick : null}
      >
        {isloading ? <FontAwesomeIcon icon={faSpinnerThird} spin /> : children}
      </button>
    </>
  );
};

export default Button;
